import { gql } from "@apollo/client";

const GET_LAST_VISITA_MEDICA = gql`
query GetLastVisitaMedica($idEvaluacion: Int!) {
    lastVisitaMedicaByIdEvaluacion(idEvaluacion: $idEvaluacion) {
        visita {
            idVisita
            idProfesional
            idProfesionalNavigation {
                idProfesional
                idFuncion
                idTipoProfesional
            }
            idComboVisitaValorTipoVisitaNavigation {
                idComboVisitaValor
            }
            idEvaluacionNavigation {
                idPaciente
                idTipoModulo
                idTipoModuloNavigation {
                    abreviacion
                }
            }
            idEvaluacion
            idFrecuencia
        }
        periodo
        visitasProgramadas
    }
}`;

export default GET_LAST_VISITA_MEDICA;

export const adaptLastVisita = (data) => ({
  ...data.lastVisitaMedicaByIdEvaluacion?.visita,
  idTipoProfesional: data.lastVisitaMedicaByIdEvaluacion?.visita?.idProfesionalNavigation?.idTipoProfesional,
  idFuncionProfesional: data.lastVisitaMedicaByIdEvaluacion?.visita?.idProfesionalNavigation?.idFuncion,
  idTipoVisita: data.lastVisitaMedicaByIdEvaluacion?.visita?.idComboVisitaValorTipoVisitaNavigation?.idComboVisitaValor,
  idTipoModulo: data?.lastVisitaMedicaByIdEvaluacion?.visita?.idEvaluacionNavigation?.idTipoModulo,
  idPaciente: data?.lastVisitaMedicaByIdEvaluacion?.visita?.idEvaluacionNavigation?.idPaciente,
  programa: data.lastVisitaMedicaByIdEvaluacion?.visita?.idEvaluacionNavigation?.idTipoModuloNavigation?.abreviacion,
  periodo: data.lastVisitaMedicaByIdEvaluacion?.periodo,
  visitasProgramadas: data.lastVisitaMedicaByIdEvaluacion?.visitasProgramadas
});